/**
 * Simple function to extract `number` from a `string` or fallback value if none found
 * @param {String} str source string as parse object
 * @param {Number} fallback fallback value if parse result is `NaN`
 */
export default function parseNum(str, fallback) {
  const numVal = parseInt(str, 10);
  return Number.isNaN(numVal) ? fallback : numVal;
}
